<template>
  <svg
    fill="none"
    height="40"
    viewBox="0 0 40 40"
    width="40"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      clip-rule="evenodd"
      d="M26.7694 11.0023C26.6798 11.0008 26.59 11 26.5 11C17.9396 11 11 17.9396 11 26.5C11 26.59 11.0008 26.6798 11.0023 26.7694C4.73974 25.5979 0 20.1025 0 13.5C0 6.04416 6.04416 0 13.5 0C20.1025 0 25.5979 4.73974 26.7694 11.0023Z"
      fill="#FF3B30"
      fill-rule="evenodd"
    />
    <path
      d="M12.654 14.3135C12.3073 13.9602 11.9873 13.6068 11.6873 13.2602C11.394 12.9135 11.1873 12.6268 11.0673 12.4068C11.054 12.3668 11.034 12.3268 11.014 12.2735C11.0007 12.2202 10.994 12.1735 10.994 12.1202C10.994 12.0135 11.0273 11.9268 11.1007 11.8535L11.6073 11.3268C11.7673 11.1668 11.894 11.0068 11.9807 10.8535C12.074 10.7002 12.1207 10.5402 12.1207 10.3802C12.1207 10.2535 12.0873 10.1135 12.0273 9.9735C11.9673 9.82683 11.8807 9.6735 11.7607 9.50683L10.214 7.32683C10.094 7.1535 9.94065 7.0335 9.76732 6.9535C9.60065 6.8735 9.41398 6.8335 9.22732 6.8335C8.73398 6.8335 8.26732 7.04016 7.84065 7.46016C7.48732 7.7935 7.23398 8.16683 7.07398 8.5735C6.91398 8.9735 6.83398 9.40683 6.83398 9.86016C6.83398 10.5535 6.99398 11.2802 7.31398 12.0402C7.63398 12.7935 8.07398 13.5535 8.62065 14.3135C9.17398 15.0735 9.79398 15.8002 10.4807 16.4935"
      stroke="#EFF7FE"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-miterlimit="10"
    />
    <path
      d="M20.1673 6.8335L6.83398 20.1668"
      stroke="#EFF7FE"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <rect
      fill="#43B284"
      height="27"
      rx="13.5"
      width="27"
      x="13"
      y="13"
    />
    <path
      d="M33.1473 30.7202C33.1473 30.9602 33.094 31.2068 32.9807 31.4468C32.8673 31.6868 32.7207 31.9135 32.5273 32.1268C32.2007 32.4868 31.8407 32.7468 31.434 32.9135C31.034 33.0802 30.6007 33.1668 30.134 33.1668C29.454 33.1668 28.7273 33.0068 27.9607 32.6802C27.194 32.3535 26.4273 31.9135 25.6673 31.3602C24.9007 30.8002 24.174 30.1802 23.4807 29.4935C22.794 28.8002 22.174 28.0735 21.6207 27.3135C21.074 26.5535 20.634 25.7935 20.314 25.0402C19.994 24.2802 19.834 23.5535 19.834 22.8602C19.834 22.4068 19.914 21.9735 20.074 21.5735C20.234 21.1668 20.4873 20.7935 20.8407 20.4602C21.2673 20.0402 21.734 19.8335 22.2273 19.8335C22.414 19.8335 22.6007 19.8735 22.7673 19.9535C22.9407 20.0335 23.094 20.1535 23.214 20.3268L24.7607 22.5068C24.8807 22.6735 24.9673 22.8268 25.0273 22.9735C25.0873 23.1135 25.1207 23.2535 25.1207 23.3802C25.1207 23.5402 25.074 23.7002 24.9807 23.8535C24.894 24.0068 24.7673 24.1668 24.6073 24.3268L24.1007 24.8535C24.0273 24.9268 23.994 25.0135 23.994 25.1202C23.994 25.1735 24.0007 25.2202 24.014 25.2735C24.034 25.3268 24.054 25.3668 24.0673 25.4068C24.1873 25.6268 24.394 25.9135 24.6873 26.2602C24.9873 26.6068 25.3073 26.9602 25.654 27.3135C26.014 27.6668 26.3607 27.9935 26.714 28.2935C27.0607 28.5868 27.3473 28.7868 27.574 28.9068C27.6073 28.9202 27.6473 28.9402 27.694 28.9602C27.7473 28.9802 27.8007 28.9868 27.8607 28.9868C27.974 28.9868 28.0607 28.9468 28.134 28.8735L28.6407 28.3735C28.8073 28.2068 28.9673 28.0802 29.1207 28.0002C29.274 27.9068 29.4273 27.8602 29.594 27.8602C29.7207 27.8602 29.854 27.8868 30.0007 27.9468C30.1473 28.0068 30.3007 28.0935 30.4673 28.2068L32.674 29.7735C32.8473 29.8935 32.9673 30.0335 33.0407 30.2002C33.1073 30.3668 33.1473 30.5335 33.1473 30.7202Z"
      stroke="currentcolor"
      stroke-miterlimit="10"
    />
    <path
      d="M30.8333 24.5003C30.8333 24.1003 30.52 23.487 30.0533 22.987C29.6267 22.527 29.06 22.167 28.5 22.167"
      stroke="currentcolor"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M33.1667 24.5002C33.1667 21.9202 31.08 19.8335 28.5 19.8335"
      stroke="currentcolor"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
